import {Bar, Line} from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    PointElement,
    LineElement,
    Colors,
} from 'chart.js';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    Colors,
);

export const ReportChart = (props: {
    selectedProductName: string,
    reportData: apiReportData,
}) => {
    return <>
        {
            props.reportData && countAllDoneProducts(props.reportData) ?
                props.selectedProductName ?
                    <Line options={chartOptions.line} data={getProductChart(props.reportData, props.selectedProductName)} /> :
                    <Bar options={chartOptions.bar} data={getAllProductsChart(props.reportData)} /> :
                <></>
        }
    </>;
};

const getAllProductsChart = (data) => {
    let chartLabels = [];
    const datasets = [];

    Object.entries(data.products).map((entry) => {
        chartLabels = [];

        const [label, stats] = entry;

        const dataset = {
            label: label,
            data: Object.entries(stats).map((statsEntry) => {
                chartLabels.push(statsEntry[0]);

                return statsEntry[1].qty || 0;
            }),
            // backgroundColor: `rgb(${getRandomInt(255)}, ${getRandomInt(255)}, ${getRandomInt(255)})`,
            // borderColor: `rgb(${getRandomInt(255)}, ${getRandomInt(255)}, ${getRandomInt(255)})`,
        };

        if (dataset.data.reduce((acc, current) => acc + current, 0)) {
            datasets.push(dataset);
        }
    });

    return {
        labels: chartLabels,
        datasets: datasets.sort((a, b) => {
            return a.data.reduce((acc, current) => acc + current, 0) <
                   b.data.reduce((acc, current) => acc + current, 0) ? 1 : -1;
        }),
    };
};

const getProductChart = (data, productName) => {
    let chartLabels = [];
    const datasets = [];

    Object.entries(data.products).map((entry) => {
        const [label, stats] = entry;

        if (label !== productName) {
            return;
        }

        chartLabels = [];

        datasets.push({
            label: 'Aktuální období',
            data: Object.entries(stats).map((statsEntry) => {
                chartLabels.push(statsEntry[0]);

                return statsEntry[1].qty || 0;
            }),
            backgroundColor: `#00A1ED`,
            borderColor: `#00A1ED`,
        });

        datasets.push({
            label: 'Předchozí období',
            data: Object.entries(stats).map((statsEntry) => {
                return statsEntry[1].qtyPrev || 0;
            }),
            backgroundColor: `#AEB4BA`,
            borderColor: `#AEB4BA`,
        });
    });

    return {
        labels: chartLabels,
        datasets: datasets,
    };
};

const chartOptions = {
    bar: {
        responsive: true,
        scales: {
            x: {
                stacked: true,
            },
            y: {
                stacked: true,
            },
        },
    },
    line: {
        responsive: true,
        plugins: {
            legend: {
                position: 'top' as const,
            },
        },
    },
};

// fixme: duplicate
const countAllDoneProducts = (data) => {
    let qtyAcc = 0;

    if (data && data.products) {
        Object.entries(data.products).map((entry) => {
            Object.entries(entry[1]).map((statsEntry) => {
                qtyAcc += statsEntry[1].qty || 0;
            });
        });
    }

    return qtyAcc;
};
